<template>
  <div class="main-content bg-default">
    <div class="main-content">
      <!-- Header -->
      <div class="header bg-gradient-success py-7 py-lg-8 pt-lg-9">

        <div class="separator separator-bottom separator-skew zindex-100">
          <svg x="0" y="0" viewBox="0 0 2560 100" preserveAspectRatio="none" version="1.1"
               xmlns="http://www.w3.org/2000/svg">
            <polygon class="fill-default" points="2560 0 2560 100 0 100"></polygon>
          </svg>
        </div>
      </div>
      <!-- Page content -->
      <b-container class="mt--8 pb-5">
        <b-row class="justify-content-center">
          <b-col lg="5" md="7">
            <b-card no-body class="bg-secondary border-0 mb-0"  :img-src="logo" :img-alt="appName">
              <b-card-body class="px-lg-5 py-lg-5">
                <div class="text-center text-muted mb-4">
                </div>
                <zoom-center-transition :duration="pageTransitionDuration" mode="out-in">
                  <router-view></router-view>
                </zoom-center-transition>
              </b-card-body>
            </b-card>
            <b-row class="mt-3">
              <b-col cols="12">
                <router-link v-if="$route.name !== 'resetEmail' && $route.name !== 'resetPassword'" :to="{name: 'resetEmail'}" class="text-light"><small>Recordar contraseña</small></router-link>
                <router-link v-if="$route.name !== 'login'" :to="{name: 'login'}" class="text-light"><small>Acceder</small></router-link>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <footer class="py-5" id="footer-main">
      <b-container >
        <b-row align-v="center" class="justify-content-xl-between">
          <b-col cols="12">
            <div class="copyright text-center text-xl-left text-muted">
              © {{year}} <a href="https://www.hitech-informatica.es" class="font-weight-bold ml-1" target="_blank">Hitech informática</a>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </footer>
  </div>
</template>
<script>
import { BaseNav } from '@/components';
import { ZoomCenterTransition } from 'vue2-transitions';
export default {
  components: {
    BaseNav,
    ZoomCenterTransition
  },
  props: {
    backgroundColor: {
      type: String,
      default: 'black'
    }
  },
  data() {
    return {
      showMenu: false,
      menuTransitionDuration: 250,
      pageTransitionDuration: 200,
      year: new Date().getFullYear(),
      pageClass: 'login-page',
      logo: '/img/logo02.png',
      appName: '',
    };
  },
  computed: {
    title() {
      return `${this.$route.name} Page`;
    }
  },
  methods: {
    toggleNavbar() {
      document.body.classList.toggle('nav-open');
      this.showMenu = !this.showMenu;
    },
    closeMenu() {
      document.body.classList.remove('nav-open');
      this.showMenu = false;
    },
    setBackgroundColor() {
      document.body.classList.add('bg-default');
    },
    removeBackgroundColor() {
      document.body.classList.remove('bg-default');
    },
    updateBackground() {
      if (!this.$route.meta.noBodyBackground) {
        this.setBackgroundColor();
      } else {
        this.removeBackgroundColor()
      }
    }
  },
  beforeMount() {
    this.logo = `${process.env.MIX_BASE_PATH}/img/logo02.png`;
    this.appName = process.env.MIX_APP_NAME;
    if (this.$cookies.isKey('jwt')) {
      this.$router.push({name:'dashboard'})
    }

  },
  beforeDestroy() {
    this.removeBackgroundColor();
  },
  beforeRouteUpdate(to, from, next) {
    // Close the mobile menu first then transition to next page
    if (this.showMenu) {
      this.closeMenu();
      setTimeout(() => {
        next();
      }, this.menuTransitionDuration);
    } else {
      next();
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler: function () {
        this.updateBackground()
      }
    }
  }
};
</script>
<style scoped>
$scaleSize: 0.8;
@keyframes zoomIn8 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
  100% {
    opacity: 1;
  }
}

.main-content .zoomIn {
  animation-name: zoomIn8;
}

@keyframes zoomOut8 {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
}

.main-content .zoomOut {
  animation-name: zoomOut8;
}
/deep/ .card-img, .card-img-top, .card-img-bottom {max-width: 260px;margin: 0 auto;margin-top:20px;}
</style>
